import React, {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useTheme} from 'components/FluentUICompat';
import {
	ComparedAssignedRequirement,
	ComparisonResult,
} from './BaselineComparisonPage.utils';
import {useAssignedRequirementsColumn} from 'features/VehicleProjects/AssignedEntities/AssignedRequirementColumns';
import {ARRAY_TYPE, OBJECT_TYPE} from 'components/EntityList/EntityUtils';

export const useComparedAssignedRequirementsColumn = () => {
	const {t} = useTranslation('features/VehicleProjects/baselineChanges');

	const {t: tStatus} = useTranslation(
		'features/VehicleProjects/baselineChanges',
		{keyPrefix: 'ComparisonResultStatus'},
	);

	const {t: tAssign} = useTranslation('features/vehicleprojects', {
		keyPrefix: 'AssignedRequirementsFields',
	});
	const theme = useTheme();

	const columnsRequirements = useAssignedRequirementsColumn();

	const columns = useMemo(() => {
		const columnCompareResult = {
			key: 'comparisonResult',
			name: t('ComparisonResult'),
			fieldName: 'comparisonResult',
			minWidth: 120,
			maxWidth: 120,
			isResizable: true,
			filterable: true,
			getFilterKey: (item: string) => item,
			getFilterLabel: (item: string) => tStatus(item),
			dataType: OBJECT_TYPE,
			onRender(item: ComparedAssignedRequirement) {
				let color = 'grey';

				switch (item.comparisonResult) {
					case ComparisonResult.New:
						color = theme.palette.green;
						break;
					case ComparisonResult.Deleted:
						color = theme.palette.red;
						break;
					case ComparisonResult.Changed:
						color = theme.palette.yellow;
						break;
					case ComparisonResult.Unchanged:
						break;

					default:
				}

				return (
					<span
						style={{
							background: color,
							color: 'white',
							padding: '5px',
							height: '100%',
							width: '100px',
						}}
					>
						{tStatus(item.comparisonResult)}
					</span>
				);
			},
		};

		const entityListFilters = [
			{
				key: 'addedAutomatically',
				filterable: true,
				filterOnFilter: false,
				dataType: OBJECT_TYPE,
				getFilterKey: (item: boolean) => item.toString(),
				getFilterLabel: (item: boolean) => tAssign(item.toString()),
			},
			{
				key: 'requirementId',
				filterable: true,
			},
			{
				key: 'vexClusters',
				filterable: true,
				dataType: ARRAY_TYPE,
			},
			{
				key: 'status',
				filterable: true,
			},
			{
				key: 'systemLevels',
				filterable: true,
				filterOnFilter: false,
				dataType: ARRAY_TYPE,
			},
			{
				key: 'markets',
				filterable: true,
				filterOnFilter: false,
				dataType: ARRAY_TYPE,
			},
			{
				key: 'keywords',
				filterable: true,
				filterOnFilter: false,
				dataType: ARRAY_TYPE,
			},
		];

		return [
			columnCompareResult,
			...columnsRequirements
				.slice(1)
				.filter(x => x.hiddenAlways !== true)
				.map(x => {
					const entityListFilter = entityListFilters.find(y => y.key === x.key);
					if (entityListFilter) {
						return {...x, ...entityListFilter};
					}
					return x;
				})
				.map(x => ({...x, sortable: false})),
		];
	}, [columnsRequirements]);

	return columns;
};
